import AnalyticsScreen from "./AnalyticsScreen";

export default AnalyticsScreen;
